export default __webpack_public_path__ + "44e672128d531b960a3cb8da1c8b0a25.svg";